const inApp = () => {
  return navigator.userAgent.indexOf('Rainbow') > -1;
};
export default inApp;